import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { AreaTools } from 'models/editor'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'

type KeywordsReportToolProps = {
  // TODO
}

export const KeywordsReportTool: FC<KeywordsReportToolProps> = (_props) => {
  const { t } = useTranslation()
  const [{ areaTool }, mapEditorDispatch] = useMapEditorContext()

  return (
    <button
      data-selected={areaTool === AreaTools.KEYWORDS_REPORT_TOOL ? true : undefined}
      onClick={() => {
        mapEditorDispatch.selectTool(AreaTools.KEYWORDS_REPORT_TOOL)
        mapEditorDispatch.setWizard(MapEditorWizards.KEYWORDS_REPORT_TOOL)
      }}
      aria-label={t('map.tools.mobility_report')}
    >
      <Tooltip label={t(`tooltips.maptools.keywords_report`)} direction="LEFT_CENTER">
        <Icon name="file-chart-line" />
      </Tooltip>
    </button>
  )
}

KeywordsReportTool.displayName = 'KeywordsReportTool'
